/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const imageDataCategorySchema = z.enum(['image', 'file'])

export type ImageDataCategorySchema = z.infer<typeof imageDataCategorySchema>
